// global-style.ts
import { setGlobalStyle } from "@adornis/chemistry/elements/theming/global-style";
import { pulsate } from "./animations";
setGlobalStyle(() => ({
  ...pulsate
}));
